export default __webpack_public_path__ + "static/media/browser-safari.e502ea09.png";